export default '/build/6ee369d8.svg'